import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { getSenstityList, deleSentityList } from "@/api/dataAll/senstityWord";
import addSentityword from "./components/addsentityWord";
export default {
  name: "senstityWord",
  components: {
    addSentityword: addSentityword
  },
  mixins: [tabulation],
  data: function data() {
    return {
      total: 0,
      searchData: {
        page_size: 10,
        page: 1
      },
      showing: false,
      tableData: [],
      addWayConfig: false,
      gameData: []
    };
  },
  created: function created() {
    this.searchData.game_id = this.rawData.game_id;
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      this.reqLoading = true;
      getSenstityList(this.searchData).then(function (res) {
        if (res.status == 200) {
          if (!res.data.data.length && _this.searchData.page > 1) {
            _this.searchClick(e - 1);
          } else {
            var list = ['game'];
            _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
            _this.total = res.data.total - 0 || 0;

            _this.$nextTick(function () {
              _this.getTableRight();
            });
          }
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleSource: function handleSource(row) {
      var _this2 = this;

      this.addWayConfig = true;
      this.showing = true;
      this.$nextTick(function () {
        _this2.$refs.addWayConfig.init(row);
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDeleteOneRecord'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleSentityList({
                  id: row.id,
                  game_id: _this3.rawData.game_id
                }).then(function (res) {
                  _this3.searchClick(_this3.searchData.page);
                });

                _this3.$message({
                  type: "success",
                  message: _this3.$t('deleteSuccessExclamation')
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};